var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2WHair4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair4_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M444.7,31.7c-4.5-2.5-9.1-4.8-13.8-6.9c-23.4-10.5-48.9-16.2-74.5-17c-1.5-0.1-3.1-0.1-4.6-0.1 c-2.9,0.1-5.9,0.2-8.8,0.4c-35.7,2.5-81.7,12.7-108.4,39.1c-7.4,6.3-13.9,13.4-19.6,21c-3.2,4.3-6.2,8.9-8.9,13.5 c-22.5,38.6-34.9,89.6-14,130.1c2.1,6.6,7.1,12.9,12.5,18c1.7,1.7,3.4,3.3,5.3,4.6c3.4,2.8,6.6,4.9,8.9,6.2 c4.5,2.7,11.9,5.9,15.6,6.6c-2.7-5.3-4.7-15.6,1.7-19.4c-2.1-1.1-2.2-8.8,0.3-13.2c3.4-7.5,10.9-16.4,17.2-22.7 c7.2-7.3,15.3-13.7,24-19.1c17.1-11.4,35.6-17,54.5-18.7c4.7-0.4,9.5-0.6,14.2-0.6c16.9,0.3,33.1,3.5,49.1,8 c5.3,1.5,10.6,3.1,15.8,4.9c33.1,7.7,77.1,47.5,104.5,13.4C543.7,122.5,494.1,59.3,444.7,31.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_4_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M518.1,202.9c4-4.2,19.4-17.9,13.1-22.3c-93.9-17.9-191.2-22.9-287-12.2c-12.6,1.4-25.2,3-37.8,4.9 c-7.1,1.2-14.2,2.6-21.3,4.1c-1.7,4.2,4.5,11.4,6.7,14.2c4.2,5.1,8.5,10.5,13.3,15.1c5.3,5.1,12,9.6,18.5,9.7 c87.3-18.7,179.8-16.2,268.3,1C503.4,217.2,510.9,210.6,518.1,202.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M233.5,169.6c-9.1,1.1-18.1,2.3-27.1,3.7c-7.1,1.2-14.2,2.6-21.3,4.1c-1.7,4.2,4.5,11.4,6.7,14.2 c4.2,5.1,8.5,10.5,13.3,15.1c5.3,5.1,12,9.6,18.5,9.7c31.7-6.8,64-10.8,96.6-12.3C288.5,198.8,256,190.3,233.5,169.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M241.1,82.2c-10,25.5-17.5,60.9-18.8,88.9c7.3-1,14.6-1.9,21.9-2.7c83.5-9.3,168.1-6.7,250.6,6 c-2.2-32.9-7.3-65.3-17.8-96C415.1,60.5,313,52.8,241.1,82.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M241.1,82.2c-8.1,20.5-14.5,47.5-17.4,71.9c11.3-2.2,22.9-4,34.7-5.5c0.6-25.2,5.2-54.5,11.6-75.9 C259.9,75.3,250.3,78.4,241.1,82.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M223.7,154.1c-0.7,5.9-1.2,11.6-1.4,17c7.3-1,14.6-1.9,21.9-2.7c83.5-9.3,168.1-6.7,250.6,6 c-0.3-5.2-0.8-10.4-1.3-15.5C411.9,139.2,309.3,137.8,223.7,154.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M446.7,149.9c-8-1.2-16.1-2.2-24.2-3.1l0.6,19.2c8.2,0.7,16.3,1.4,24.5,2.3L446.7,149.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2WHair4);
export default __webpack_public_path__ + "static/media/m-hat2_w-hair4.c5b4b7793cde64fe9ef21a5651892ed4.svg";
export { ForwardRef as ReactComponent };